import { render, staticRenderFns } from "./plan2231.vue?vue&type=template&id=c36f4c3a&scoped=true"
import script from "./plan2231.vue?vue&type=script&lang=js"
export * from "./plan2231.vue?vue&type=script&lang=js"
import style0 from "./plan2231.vue?vue&type=style&index=0&id=c36f4c3a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c36f4c3a",
  null
  
)

export default component.exports